<template>
<div>
  <!-- <w-predict-target-obj-tree class="mr-r30" style="width:300px; float:left;" ref="targetObjTree" @select-node="selectNode" :force-select-leaf="true"></w-predict-target-obj-tree> -->
  <div class="mr-r30" style="width:360px; float:left;">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="title-h4 mr-r10">관리 대상</span>
        <el-select  class="mr-r4" style="width: 150px;" v-model="objDefineId">
          <el-option v-for="(item, index) in objDefineList" :key="index" :label="item.objDefineName" :value="item.objDefineId"></el-option>
        </el-select>
      </div>
      <w-header-search-button size="mini" @click="targetShowSearchTool = !targetShowSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper ref="eventObjTable" v-loading="loading" :columns="targetObjColumn" :data="setTargetObjList"  @condition-change="loadEventObjTable" highlight-current-row
    row-class-name="c-pointer" :pagination="true" @cell-click="selectTargetObjInfo" :show-search-tool="targetShowSearchTool" :show-custom-header="true" remote :total="targetTotal">
    </el-table-wrapper>
  </div>
  <div style="float: right; width: calc(100% - 390px);">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="title-h4 mr-r10">학습 데이터 자원</span>
        <div class="setting-addel">
          <el-button size="mini" @click="addCustomLearnDataSet"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" :disabled="!isMultiSelection" @click="deleteRscCustomLearnDataSet"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" size="mini" type="primary" :disabled="!isMultiSelection" @click="onClickLearnRscGroupSave">그룹 저장</el-button>
        <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="rscLearnTableData" :columns="rscLearnTableColumn" ref="rscLearnTable" @selection-change="changeHandleSelection" @cell-dblclick="updateCustomLearnDataSet"
      row-class-name="c-dblclick" remote :total="total" :pagination="true" style="width:100%;" :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="loadRscLearnTableData">
    </el-table-wrapper>
  </div>
  <w-predict-custom-learn-data-setting-popup ref="predictCustomLearnDataSettingPopup" @save="loadRscLearnTableData"/>
  <w-rsc-learn-data-group-save-popup ref="rscLearnDataGroupSavePopup" :selectObjtypeId="selectObjDefineId" :selectionRscLearnData="selectionDataList" @reload="reloadData"></w-rsc-learn-data-group-save-popup>
</div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import WPredictTargetObjTree from '@/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/PredictTargetObjTree';
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';
import WPredictCustomLearnDataSettingPopup from './popup/PredictCustomLearnDataSettingPopup';
import WRscLearnDataGroupSavePopup from './popup/RscLearnDataGroupSavePopup';

export default {
  name: 'WCustomLearnDataSetting',
  components: {
    WPredictTargetObjTree,
    WPredictCustomLearnDataSettingPopup,
    WRscLearnDataGroupSavePopup,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      showSearchTool: false,
      selectObjDefineId: null,
      total: 0,
      selectionDataList: null,
      targetObjParams: {},
      rscLearnTableData: [],
      rscLearnTableColumn: [
        {
          type: 'selection',
          width: 50,
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          remoteProp: 'rt.rsctype_name',
          width: 300,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          remoteProp: 'r.rsc_name',
          width: 300,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKeyName',
          label: '자원 키',
          remoteProp: 'kvn.value_name',
          width: 150,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'predictDatetime',
          label: '예측일',
          // remoteProp: 'pcld.predict_datetime',
          searchType: 'date',
          formatter: this.getDateFormatter,
          width: 250,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'learnDataSetLabel',
          label: '학습 데이터',
          remoteProp: 'pcld.learn_data_set_label',
          searchable: false,
        },
      ],
      setTargetObjList: [],
      targetTotal: 0,
      targetShowSearchTool: false,
      objParams: {
        objId: null,
        objDefineId: null,
      },
      objDefineId: null,
      loading: false,
      objDefineList: [],
      targetObjColumn: [
        {
          prop: 'objDefineName',
          label: '관리 구분',
          remoteProp: 'od.obj_define_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'objName',
          label: '장비명',
          remoteProp: 'obj.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    isMultiSelection() {
      return !isEmpty(this.selectionDataList) && (this.selectionDataList.length > 0);
    },
  },
  watch: {
    objDefineId: {
      handler(value) {
        if (!isNil(value)) {
          this.targetObjParams.objId = null;
          if (value === 'all') {
            this.targetObjParams.objDefineId = null;
          } else {
            this.targetObjParams.objDefineId = value;
          }
          this.loadEventObjTable();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      if (this.activeTab === 'WCustomLearnDataSetting') {
        this.objDefineId = null;
        this.loadPredictTargetData();
      }
    },
    /**
     * 자원 학습 데이터 설정 리스트를 로드한다.
     * @author yelim
     */
    loadRscLearnTableData() {
      const tableParams = this.$refs.rscLearnTable.getParameter();
      const objDefineId = (this.objDefineId === 'all') ? null : this.objDefineId;
      const params = {
        objDefineId,
        objId: this.targetObjParams.objId,
        ...tableParams,
      };
      EventPredictSettingsAPI.getRscLearnDataList(params).then((response) => {
        if (response.data.success) {
          this.rscLearnTableData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      } else if (isNil(value) && isNil(column) && !isNil(row)) {
        return getDateToString(row);
      }
      return EMPTY_TEXT;
    },
    /**
     * 선택한 학습 데이터 자원을 그룹 저장하는 팝업을 오픈한다.
     * @author yelim
     */
    onClickLearnRscGroupSave() {
      this.$refs.rscLearnDataGroupSavePopup.open();
    },
    /**
     * 학습 데이터 자원을 선택한다.
     * @author yelim
     */
    changeHandleSelection(rows) {
      this.selectionDataList = rows;
    },
    /**
     * 학습 데이터 자원을 추가 팝업을 띄운다.
     * @author yelim
     */
    addCustomLearnDataSet() {
      this.$refs.predictCustomLearnDataSettingPopup.open(this.targetObjParams);
    },
    /**
     * 학습 데이터 자원을 수정 팝업을 띄운다.
     * @author yelim
     */
    updateCustomLearnDataSet(row) {
      this.$refs.predictCustomLearnDataSettingPopup.open(this.targetObjParams, row);
    },
    /**
     * 추가 / 삭제하는 경우 관리대상. 학습 데이터 자원 목록을 재조회한다.
     * @author yelim
     * @return {[type]}
     */
    reloadData() {
      this.loadRscLearnTableData();
    },
    /**
     * 학습 데이터 자원을 삭제한다.
     * @author yelim
     */
    deleteRscCustomLearnDataSet() {
      const target = '학습 데이터 자원';
      const action = msgUtil.action.DELETE;
      const params = [];
      this.selectionDataList.forEach((item) => {
        params.push({
          hashkeyId: item.hashkeyIdString,
          predictDatetime: item.predictDatetime,
        });
      });
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        EventPredictSettingsAPI.deleteCustomLearnDataSet(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.reloadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          throw new Error(e);
        });
      });
    },
    loadPredictTargetData() {
      EventPredictSettingsAPI.getPredictTargetObjDefine().then((response) => {
        if (response.data.success) {
          const objDefineList = [];
          const result = response.data.data;
          objDefineList.push({ objDefineName: '전체', objDefineId: 'all' });
          this.objDefineList = objDefineList.concat(result);
          this.objDefineId = this.objDefineList[0].objDefineId;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        throw new Error(e);
      });
    },
    selectTargetObjInfo(row) {
      const params = {};
      if (!isNil(row)) {
        params.objId = row.objId;
        params.objDefineId = row.objDefineId;
      }
      this.targetObjParams = params;
      this.loadRscLearnTableData();
    },
    loadEventObjTable() {
      const tableParams = this.$refs.eventObjTable.getParameter();
      const objDefineId = (this.objDefineId === 'all') ? null : this.objDefineId;
      const params = {
        objDefineId,
        ...tableParams,
      };
      EventPredictSettingsAPI.getPredictTargetObjInfo(params).then((response) => {
        if (response.data.success) {
          this.setTargetObjList = response.data.data;
          this.selectTargetObjInfo(this.setTargetObjList[0]);
          this.$refs.eventObjTable.getTable().setCurrentRow(this.setTargetObjList[0]);
          this.targetTotal = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        throw new Error(e);
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/CustomLearnDataSetting/index.vue